import {ItemAttribute} from '@emm/core/models/item-attribute.model';
import {FormlyFieldConfigMap} from '@emm/shared/formly/maps/formly-field-config.map';
import {ItemAttributeType} from '@emm/core/models/enums';
import {FormlyUtil} from '@emm/shared/formly/formly.util';

export const itemAttributeFieldMap: FormlyFieldConfigMap<ItemAttribute> = {

    [ItemAttributeType.Text]: (attribute: ItemAttribute, index: number, isReadOnly: boolean, language: string) => {
        return {
            key: attribute.jsonProperty,
            templateOptions: {
                appearance: attribute.scope === 'GLOBAL' ? 'fill' : 'outline',
                disabled: isReadOnly,
                index,
                isDirty: attribute.isDirty,
                isOverride: attribute.isOverride,
                label: attribute.name,
                maxLength: 512,
                required: attribute.required && language === 'en',
                scope: attribute.scope
            },
            validators: {
                validationExpression: (formControl) => {
                    if (!attribute.validationExpression) { return true; }
                    return (new RegExp(attribute.validationExpression)).test(formControl.value);
                }
            },
            type: 'input',
            wrappers: ['form-field-horizontal']
        };
    },

    [ItemAttributeType.TextArea]: (attribute: ItemAttribute, index: number, isReadOnly: boolean, language: string) => ({
        key: attribute.jsonProperty,
        templateOptions: {
            appearance: attribute.scope === 'GLOBAL' ? 'fill' : 'outline',
            disabled: isReadOnly,
            index,
            isDirty: attribute.isDirty,
            isOverride: attribute.isOverride,
            label: attribute.name,
            maxLength: 512,
            required: attribute.required && language === 'en',
            rows: 3,
            scope: attribute.scope
        },
        type: 'textarea-autosize',
        wrappers: ['form-field-horizontal']
    }),

    [ItemAttributeType.Number]: (attribute: ItemAttribute, index: number, isReadOnly: boolean, language: string) => ({
        key: attribute.jsonProperty,
        templateOptions: {
            appearance: attribute.scope === 'GLOBAL' ? 'fill' : 'outline',
            disabled: isReadOnly,
            index,
            isDirty: attribute.isDirty,
            isOverride: attribute.isOverride,
            label: attribute.name,
            maxLength: 512,
            required: attribute.required && language === 'en',
            scope: attribute.scope,
            type: 'number'
        },
        type: 'input',
        wrappers: ['form-field-horizontal']
    }),

    [ItemAttributeType.Boolean]: (attribute: ItemAttribute, index: number, isReadOnly: boolean, language: string) => ({
        key: attribute.jsonProperty,
        templateOptions: {
            appearance: attribute.scope === 'GLOBAL' ? 'fill' : 'outline',
            disabled: isReadOnly,
            index,
            isDirty: attribute.isDirty,
            isOverride: attribute.isOverride,
            label: attribute.name,
            options: [...FormlyUtil.getBooleanList(attribute.required)],
            required: attribute.required && language === 'en',
            scope: attribute.scope
        },
        type: 'select',
        wrappers: ['form-field-horizontal']
    }),

    [ItemAttributeType.Select]: (attribute: ItemAttribute, index: number, isReadOnly: boolean, language: string) => ({
        key: attribute.jsonProperty,
        templateOptions: {
            appearance: attribute.scope === 'GLOBAL' ? 'fill' : 'outline',
            disabled: isReadOnly,
            index,
            isDirty: attribute.isDirty,
            isOverride: attribute.isOverride,
            label: attribute.name,
            options: [...attribute.options],
            required: attribute.required && language === 'en',
            scope: attribute.scope
        },
        type: 'select',
        wrappers: ['form-field-horizontal']
    }),

    [ItemAttributeType.MultiSelect]: (attribute: ItemAttribute, index: number, isReadOnly: boolean, language: string) => (
        {
        key: attribute.jsonProperty,
        templateOptions: {
            appearance: attribute.scope === 'GLOBAL' ? 'fill' : 'outline',
            disabled: isReadOnly,
            index,
            isDirty: attribute.isDirty,
            isOverride: attribute.isOverride,
            label: attribute.name,
            multiple: true,
            options: [...attribute.options],
            placeholder: 'Select',
            required: attribute.required && language === 'en',
            scope: attribute.scope,
            selectAllOption: 'Select All'
        },
        type: 'select',
        wrappers: ['form-field-horizontal']
    }),

    [ItemAttributeType.Image]: (attribute: ItemAttribute, index: number, isReadOnly: boolean, language: string) => ({
            key: attribute.jsonProperty,
            templateOptions: {
                appearance: attribute.scope === 'GLOBAL' ? 'fill' : 'outline',
                disabled: isReadOnly,
                index,
                isDirty: attribute.isDirty,
                isOverride: attribute.isOverride,
                label: attribute.name,
                maxLength: 512,
                required: attribute.required && language === 'en',
                scope: attribute.scope
            },
            type: 'input',
            wrappers: ['form-field-horizontal']
        })

};
